import Navbar from "../components/Header";
import React, { useState } from "react";
import UpcomingYatraCart from "../pages/UpcomingYatra";
import About from "./About";
import OurServices from "./OurServices";
import PastYatraCart from "../pages/PastYatra";
import Gallery from "../pages/Gallery";
function HomePage() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <>
      <div>
        <main className="p-8 text-center md:mt-24 mt-20 relative">
          {/* Left Side Image */}
          <img
            src="/photo1-min.png"
            alt="Left Decoration"
            className="absolute left-0 w-16 sm:w-20 md:w-44 z-0 opacity-50 lg:opacity-100"
          />

          {/* Right Side Image */}
          <img
            src="/photo2-min.png"
            alt="Right Decoration"
            className="absolute right-0 w-16 sm:w-20 md:w-44 z-0 opacity-50 lg:opacity-100"
          />
          <div className="relative z-10">
            <h1 className="text-lg md:text-5xl text-orange-800 md:mb-4 font-yatra">
              वारकरी परिवार मध्ये तुमचं स्वागत आहे!
            </h1>

            <p className="text-lg md:text-2xl text-gray-700 mb-4 font-yatra md:px-0 px-10">
              येथे आपण आगामी आणि मागील यात्रा पाहू शकता.
            </p>

            <h2 className="text-lg sm:text-xl md:text-2xl font-yatra font-semibold mb-2 md:mb-4 bg-gradient-to-r from-orange-600 via-red-500 to-orange-600 text-transparent bg-clip-text animate-pulse">
              चला आपल्या अंतर्मनाचा शोध घेऊयात, आध्यात्मिक प्रवास करूयात
            </h2>
          </div>
        </main>

        <UpcomingYatraCart />
        <About />
        <OurServices />
        <Gallery />
        <PastYatraCart />
      </div>
    </>
  );
}

export default HomePage;
